import { initializeApp } from "firebase/app";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
import { getStorage } from "firebase/storage";
// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyAfc53q6Fj4DoqME6pesApjg9Tx_bBcTBY",
  authDomain: "github-bryan.firebaseapp.com",
  databaseURL: "https://github-bryan.firebaseio.com",
  projectId: "github-bryan",
  storageBucket: "github-bryan.appspot.com",
  messagingSenderId: "1092202350883",
  appId: "1:1092202350883:web:ccb786e13f501a9debe496",
  measurementId: "G-T37HG7QPGV",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
provider.addScope("https://www.googleapis.com/auth/contacts.readonly");

export { db, provider, storage };
